import React from 'react';
import { InnerContentTypes, TPrivacyContentFieldItem, TPrivacyContentItems } from '../../types/PrivacyStatement.types';
import { RichText, Text } from "@sitecore-jss/sitecore-jss-react";
import Accordion from '../Accordion';

const SectionContent = (props: TPrivacyContentItems) => {
    const { fields } = props;
    const items = fields.items;

    const ItemContent = (item: TPrivacyContentFieldItem) => {
        if (InnerContentTypes.RichText === item.fields.templateId) {
            return (
                <RichText field={item.fields.contentDetail} />
            );
        }
        return (
            <Accordion accordionContentDetail={item.fields.accordionContentDetail} accordionContentTitle={item.fields.accordionContentTitle} />
        )
    };

    return (
        <>
            <Text tag={'h2'} field={fields.anchorContentTitle} className="privacy-statement-v2__content-title" />
            <div className='privacy-statement-v2__content-items'>
                {
                    items && items.map((item) => {
                        return <ItemContent {...item} />
                    })
                }
            </div>
        </>
    )
}

export default SectionContent;